import React, { lazy, Suspense } from 'react';
const RemotePurchasesOrangePayFormDynamicImport = lazy(() => import('./remote-purchases-orange-pay-form'));
// making this a container now because once we add orange pay we will have to dynamically import the form component
export const RemotePurchasesOrangePayContainer = ({ onCloseForm, card, }) => {
    return typeof window !== 'undefined' ? (React.createElement(Suspense, { fallback: React.createElement("div", null) },
        React.createElement(RemotePurchasesOrangePayFormDynamicImport, { onCloseForm: onCloseForm, card: card }))) : (React.createElement("div", null));
};
